(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["comparison-slider"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-sold-browse]').forEach(function (container) {
      var root = container.closest('comparison-slider-component');
      if (!root) return;
      var poolEl = root.querySelector('script[data-sold-pool]');
      if (!poolEl) return;
      var pool = JSON.parse(poolEl.textContent);
      var beforeImg = root.querySelector('.before-image');
      var afterImg = root.querySelector('.after-image');
      var pairIndex = 0;

      function setImage(img, item) {
        if (!img) return;
        // image_tag renders a srcset, and browsers resolve the displayed
        // resource from srcset/sizes over a JS-set src -- so the swap is
        // invisible unless the stale srcset is cleared too.
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = item.url;
        img.alt = item.title;
      }

      function render() {
        if (!pool.length) return;
        var bIndex = pairIndex % pool.length;
        var aIndex = (pairIndex + 1) % pool.length;
        var b = pool[bIndex];
        var a = pool[aIndex];
        // Defensive guard: the two slots must never show the same photo,
        // even if the pool ever contains a duplicate/missing image.
        var guard = 0;
        while (a && b && (a.url === b.url || !a.url) && guard < pool.length) {
          aIndex = (aIndex + 1) % pool.length;
          a = pool[aIndex];
          guard++;
        }
        setImage(beforeImg, b);
        setImage(afterImg, a);
      }

      function goPrev() {
        // Advance by a full pair, not one slot at a time, so a click
        // never leaves one of the two previously-shown photos behind
        // in the other slot.
        pairIndex = (pairIndex - 2 + pool.length * 2) % pool.length;
        render();
      }

      function goNext() {
        pairIndex = (pairIndex + 2) % pool.length;
        render();
      }

      var prevBtn = container.querySelector('[data-sold-prev]');
      var nextBtn = container.querySelector('[data-sold-next]');
      if (prevBtn) prevBtn.addEventListener('click', goPrev);
      if (nextBtn) nextBtn.addEventListener('click', goNext);

      // Clicking either photo does the same thing as its nearer arrow.
      if (beforeImg) {
        beforeImg.style.cursor = 'pointer';
        beforeImg.addEventListener('click', goPrev);
      }
      if (afterImg) {
        afterImg.style.cursor = 'pointer';
        afterImg.addEventListener('click', goNext);
      }
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-signup-discount-dialog]').forEach(function (dialog) {
    if (dialog.dataset.signupDiscountBound) return;
    dialog.dataset.signupDiscountBound = 'true';

    if (typeof dialog.showModal === 'function') dialog.showModal();

    var closeBtn = dialog.querySelector('[data-signup-discount-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dialog.close();
      });
    }

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    var copyBtn = dialog.querySelector('[data-signup-discount-copy]');
    var codeEl = dialog.querySelector('[data-signup-discount-code]');
    if (copyBtn && codeEl) {
      copyBtn.addEventListener('click', function () {
        var text = codeEl.textContent.trim();
        if (navigator.clipboard) {
          navigator.clipboard.writeText(text);
        }
        copyBtn.textContent = 'Copied!';
        setTimeout(function () {
          copyBtn.textContent = 'Copy code';
        }, 2000);
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["menu"] && !Shopify.designMode) return;
  try {
    // Footer submenu hover: keep it open for a short grace period after the
  // cursor leaves the heading, so moving the mouse down into the flyout
  // (which sits below the heading with a small gap) doesn't close it first.
  document.querySelectorAll('.footer-content .menu .menu__details').forEach(function (details) {
    if (details.dataset.hoverBound) return;
    details.dataset.hoverBound = 'true';

    var closeTimer = null;

    function open() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      details.classList.add('is-hover-open');
    }

    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        details.classList.remove('is-hover-open');
        closeTimer = null;
      }, 300);
    }

    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', scheduleClose);
  });
  } catch(e) { console.error(e); }
})();

})();
